import React from 'react';
import styled from 'styled-components';
import VideoInput from './VideoInput';
import EnterButton from './Buttons/EnterButton';
import { width100 } from '../constants';

const EndComponent = styled.div`
  ${width100}
  max-width: 45rem;
  margin-top: 4rem;
  display: flex;
`;

const Initials = styled.div`
  ${width100}
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function End() {
  const [initials, setInitials] = React.useState('   ');

  const inputs = [];
  for (let i = 0; i < 3; i += 1) {
    inputs.push(<VideoInput index={i} initials={initials} setInitials={setInitials} />);
  }

  console.log(initials);

  return (
    <EndComponent>
      <Initials>
        {inputs}
      </Initials>
      <EnterButton initials={initials} />
    </EndComponent>

  );
}
